module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/book-details/book_detail_08-8cb6aaa58413d5bd06745fbef731c6c0.png";